// extracted by mini-css-extract-plugin
module.exports = {"activityListItem":"rm8mC","activityListItemDescription":"I9bVu","descriptionTextWrapper":"D-eDQ","activityIconWrapper":"phhCW","withPadding":"fkp4g"};